/** Keystrokes bound for someone typing must never drive canvas shortcuts. */
export const isTypingTarget = (target: EventTarget | null): boolean =>
  target instanceof HTMLElement &&
  (target.isContentEditable ||
    Boolean(target.closest("input, textarea, select")));
